export default {
  urlresource: "https://certsverify.thirdeyedata.ai:8020/",
  // urlresource: "https://certs.thirdeyedata.io:8000/certs/",
};
